"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _spas = require("./spas");
Object.keys(_spas).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _spas[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _spas[key];
    }
  });
});
